module.exports = __webpack_public_path__ + "img/drbronner_2025_camper_800.4307bd73.webp";